// Nivo 4 / T13 (spec §4.1) — manual bookkeeping entries an organization keeps
// alongside the payments ledger. They are NOT realized money: the ledger stays
// the single source of collected/refunded amounts, and these rows are the
// owner's own record of costs and off-platform income.
export enum FinanceEntryDirection {
  EXPENSE = 'EXPENSE',
  INCOME = 'INCOME',
}

// `MONTHLY` is a segment of a series: canonical first-of-month `occurredOn`,
// last-of-month (or open-ended) `endsOn`. There is no day-of-month recurrence
// and no prorating — see the DB CHECK `chk_fe_monthly_canonical`.
export enum FinanceEntryRecurrence {
  NONE = 'NONE',
  MONTHLY = 'MONTHLY',
}
